// A customer's billing terms (F-29): days to pay and whether every job needs a PO. They are the
// bill-to's: a property manager or strata an address invoices, else the customer themselves.

import type { Customer } from '../types.ts';

export interface Terms {
  poRequired: boolean;
  /** Days to pay; null or 0 is due on receipt. */
  termsDays: number | null;
}

/** "Net 30", or "Due on receipt". */
export const daysText = (days: number | null) => (days ? `Net ${days}` : 'Due on receipt');

/** "Net 30 · PO required", "PO required", "Net 15"; '' when there is nothing to say (due on receipt, no PO). */
export function termsText(t: Terms | null | undefined): string {
  if (!t) return '';
  return [...(t.termsDays ? [`Net ${t.termsDays}`] : []), ...(t.poRequired ? ['PO required'] : [])].join(
    ' · ',
  );
}

/** Whose terms a job at this address follows: the address's bill-to's, else the customer's own. */
export function termsAt(
  c: Pick<Customer, 'id' | 'displayName' | 'billingTerms' | 'locations'>,
  locationId: string | null,
): { customerId: string; name: string; billTo: boolean; terms: Terms | null } {
  const b = c.locations.find((l) => l.id === locationId)?.billTo;
  return b
    ? {
        customerId: b.customerId,
        name: b.name,
        billTo: true,
        terms:
          b.poRequired === undefined ? null : { poRequired: b.poRequired, termsDays: b.termsDays ?? null },
      }
    : { customerId: c.id, name: c.displayName, billTo: false, terms: c.billingTerms ?? null };
}
